import React, { Component } from "react";
import { Checkbox } from "antd";
//图片
import Tit from "images/title.png";

function App(props){
	const { i18n, userInfo, checked, toCheck, toNext, toNotice, handleChange } = props;

	return(
		<div className="video-main">
			<p className="video-main-hello">{(i18n.index.title) + userInfo.userName}</p>
			<div className = "video-main-tit">
				<img src={Tit} />
				<p>{i18n.index.titlePCTips}</p>
			</div>
			<div className="video-main-yun">
				{i18n.index.subtitlePC1}
				<span>{i18n.lang == "en_us" ? (userInfo.corpNameEn || userInfo.corpName) : userInfo.corpName}</span>
				{i18n.index.subtitlePC2}
			</div>
			<p className="video-main-w">{userInfo.postName}</p>
			<button className={"video-main-btn " + (checked?"video-main-checkBtn":"video-main-disabled")}
				onClick={toCheck}>{i18n.index.checkBtnText}</button>
			<button className={"video-main-btn " + (checked?"video-main-next":"video-main-disabled")}
				onClick={toNext}>{i18n.index.skipBtnText}</button>
			{/*<button className="video-main-checkBtn video-main-btn" onClick={() => toNotice(-1)}>试录一次</button>
			<button className="video-main-next video-main-btn" onClick={() => toNotice(0)}>立即开始录制</button>*/}
			<div className="video-main-check">
				<Checkbox checked={checked} onChange={handleChange} />
				<p className="video-main-read">{i18n.index.instructionsText1}
					<span onClick={toNotice}>{i18n.index.instructionsText2}</span>
				</p>
			</div>
		</div>
	)
}

export default App;